import { defineMessages } from 'react-intl';

const messages = defineMessages({
  DocumentTemplates: 'Document templates',
  ExampleDocumentTemplates: 'Example document templates',
  AllTemplateTypes: 'All template type',
  AllLanguages: 'All languages',
  AllCompanies: 'All companies',

  Name: 'Name',
  DocumentTemplateType: 'Template type',
  Language: 'Language',
  RelationType: 'Relation type',
  OwnCompany: 'Own company',
  Actions: 'Actions',
  All: 'All',
  AddDocumentTemplate: 'Add document template',
  TemplateType: 'Template type',
  Add: 'Add',
  Cancel: 'Cancel',
  DeleteTemplate: 'Delete template',
  DeleteTemplateConfirmationMsg: 'Are you sure you want to delete this template?',
  File: 'File',
  AntiMoneyLaundering: 'Anti-money laundering',
  Download: 'Download',
  ShowAvailablePlaceholders: 'Show available placeholders',
  Placeholders: 'Placeholders',
  PlaceholdersModalTitle: 'Use these placeholders in your template',
  PlaceholdersModalInfo:
    'AdminPulse will automatically try to fill out the placeholders listed below when generating an assignment letter. Custom placeholders such as {remark} can be added to the template and will be asked to fill out during the generation process.',
  Close: 'Close',
  SelectTemplateType: 'Select a template type',
  Preview: 'Preview',
  ErrorWhileLoadingPreview: 'An error ocurred while loading the preview',
  Edit: 'Edit',
  RelationLinksPlaceholders: 'Relation link placeholders',
  Search: 'Search',
  AuthorizationLetter: 'Authorization letter',
  AssignmentLetter: 'Assignment letter',
  Questionnaires: 'Questionnaires',
  TaskPlaceholders: 'Task placeholders',
  TaskTemplate: 'Task template',
  Other: 'Other',
  Copy: 'Copy',
  CheckoutBrowser: 'Checkout in browser',
  CheckoutApp: 'Checkout in app',
  Checkin: 'Checkin',
  DiscardCheckout: 'Discard checkout',
  ContinueEditing: 'Continue editing',
  MsgCheckinDocumentError: 'Error while checking in document',
  MsgCheckoutDocumentError: 'Error while checking out document',
  CheckinDocumentConfirmationMsg:
    'Are you sure you want to discard this checkout? It is currently checked out by {name} so this may result in a loss of their changes.',
  CheckedOutSuccesfull: 'Successfully checked out file.',
  CheckedinSuccesfull: 'Successfully checked in file.',
  DocumentCheckedOut: 'Document is checked out by {name}',
});

export default messages;
